import { attr } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const Component = ApplicationRecord.extend({
  static: {
    jsonapiType: 'components',
  },
  attrs: {
    htmlElements: attr(),
  },
})

export default Component
